import {
  addDays,
  addMonths,
  isAfter,
  isBefore,
  isToday,
  isWithinInterval,
  subDays,
  subMonths,
} from "date-fns";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { startOfToday } from "date-fns/esm";

export const birthDateLabel = (
  texts: any,
  lang: any,
  born: BooleanFormType | undefined,
  multipleChildren: BooleanFormType | undefined,
): string => {
  const moreThenOneChild = multipleChildren === BooleanFormType.TRUE;
  const childBorn = born === BooleanFormType.TRUE;
  if (moreThenOneChild && childBorn) {
    return `${texts.labelChildren[lang]} ${texts.labelNewborn[lang]}`;
  } else if (moreThenOneChild && !childBorn) {
    return `${texts.labelPregnant[lang]}`;
  } else if (!moreThenOneChild && childBorn) {
    return `${texts.labelChild[lang]} ${texts.labelNewborn[lang]}`;
  } else if (!moreThenOneChild && !childBorn) {
    return `${texts.labelPregnant[lang]}`;
  }
  return "";
};

export const multipleChildrenLabel = (
  texts: any,
  lang: any,
  born: BooleanFormType | undefined,
): string => {
  if (born === BooleanFormType.TRUE) {
    return texts.labelNewborn[lang];
  }
  return texts.labelPregnant[lang];
};

export const notWithinIntervalError = (
  texts: any,
  lang: any,
  date?: Date,
  childBorn?: BooleanFormType,
): string => {
  if (
    date &&
    childBorn === BooleanFormType.TRUE &&
    !withinChildBornInterval(date)
  ) {
    return `${texts.dateOfBirthError[lang]}`;
  } else if (
    date &&
    childBorn === BooleanFormType.FALSE &&
    !withinDueDateInterval(date)
  ) {
    return `${texts.dueDateError[lang]}`;
  }
  return "";
};

export const minDate = (childBorn?: BooleanFormType): Date => {
  if (childBorn === BooleanFormType.TRUE) {
    return bornMinDate();
  }
  return dueMinDate();
};

export const maxDate = (childBorn?: BooleanFormType): Date => {
  if (childBorn === BooleanFormType.TRUE) {
    return bornMaxDate();
  }
  return dueMaxDate();
};

export const withinChildBornInterval = (
  dateOfBirth: Date | undefined,
): boolean => {
  if (dateOfBirth) {
    const today = startOfToday();
    const lastPurchaseDate = subDays(addMonths(dateOfBirth, 3), 1);
    if (
      (isToday(dateOfBirth) || isBefore(dateOfBirth, today)) &&
      !isAfter(today, lastPurchaseDate)
    ) {
      return true;
    }
  }
  return false;
};
const bornMinDate = (): Date => addDays(subMonths(startOfToday(), 3), 1);
const bornMaxDate = (): Date => startOfToday();

export const withinDueDateInterval = (dueDate: Date | undefined): boolean => {
  if (dueDate) {
    const firstPurchaseDate = dueMinDate();
    const lastPurchaseDate = dueMaxDate();
    if (isBefore(firstPurchaseDate, lastPurchaseDate)) {
      return isWithinInterval(dueDate, {
        start: firstPurchaseDate,
        end: lastPurchaseDate,
      });
    }
  }
  return false;
};
const dueMinDate = (): Date => subDays(startOfToday(), 14);
const dueMaxDate = (): Date => addDays(startOfToday(), 116);
